function About() {
  return (
    <>
      <div id="about" className="text-white flex flex-col justify-center items-center pt-20 pb-2 lg:px-8 sm:px-6 box-border">
        <h1 className="m-0 text-xl font-bold mb-5">About Me</h1>
        <p className="leading-normal text-medium text-justify">
          As a front-end developer, I bring expertise in crafting engaging and user-friendly web experiences. Proficient in HTML, CSS, and JavaScript, I specialize in building responsive and visually appealing interfaces. My skill set includes working with popular frameworks like React.js and
          Vue.js to create dynamic and interactive websites. With a keen eye for design and a commitment to staying updated on industry trends, I strive to deliver high-quality solutions that exceed user expectations.
        </p>
        <p className="flex md:flex-row sm:flex-col justify-center items-center mt-3">
          You want to work with me ?
          <a className="bg-gray-800 rounded-lg m-3" href="Aqil_Resume.pdf" download="Aqil_Resume">
            <p id="download">Download Resume</p>
          </a>
        </p>
      </div>
    </>
  );
}
export default About;
